import SessionManager from "@Core/session";
import { IAssessmentDetails, IAssessmentInstanceDetails } from "@Models/IAssessmentDetails";
import { useSearchParams } from "@Utils";
import { useEffect } from "react";
import { IUseAssessmentData } from "../types";
import { useUserAssessmentsInstancesQuery } from "./../queries";

interface IUseStudentAssessmentsData extends IUseAssessmentData<IAssessmentDetails> {
  assessmentInstance: IAssessmentInstanceDetails;
  assessmentInstances: IAssessmentInstanceDetails[];
}

const useStudentAssessments = (): IUseStudentAssessmentsData => {
  const { userId } = SessionManager.getServiceUser();
  const [searchParams, setSearchParams] = useSearchParams();

  // ** Search params ** //
  const tab: string = searchParams.get("tab");
  const assessmentId = searchParams.get("assessment");

  // ** Queries and Mutations ** //
  const {
    data: assessmentInstances,
    isFetching,
    isFetched,
    isLoading,
    refetch: onReload,
  } = useUserAssessmentsInstancesQuery(userId);

  const assessmentInstance = !!assessmentId
    ? assessmentInstances?.find((ai) => ai.assessmentId === assessmentId)
    : null;

  // ** Event Handlers ** //
  useEffect(() => {
    if (!assessmentInstance || assessmentInstance?.status === tab) return;

    setSearchParams({ tab: assessmentInstance.status, assessment: assessmentId }, { replace: true });
  }, [assessmentId, assessmentInstance, setSearchParams, tab]);

  // ** Return Data ** //
  return {
    assessmentInstance,
    assessmentInstances: assessmentInstances.filter((ai) => ai.status === tab),
    isFetched,
    isFetching,
    isLoading: !isFetched || isLoading,
    onReload,
  };
};

export default useStudentAssessments;
